import { FirebaseDocChangeType } from 'firebase/index'
import { CheckoutItemType } from 'types/checkoutItem'
import { OrderType } from 'types/checkout'
import { Action, Dispatch } from 'redux'
import { fetchOrdersAction } from 'reducks/checkout/actions'

const mergeListeningCheckoutWithItems = (
  changes: FirebaseDocChangeType[],
  items: CheckoutItemType[],
  currentOrders: OrderType[],
  dispatch: Dispatch<Action>,
  sortKey: 'created_at' | 'updated_at' | 'checkout_at' | 'date' | 'pickup_time',
  sortOrder: 'asc' | 'desc'
): void => {
  const orders: OrderType[] = currentOrders
  for (let i = 0; i < changes.length; i = (i + 1) | 0) {
    const change = changes[i]
    const data = change.doc.data() as OrderType
    data.checkout_id = change.doc.id
    data.items = items.filter((item) => item.checkout_id === change.doc.id)
    // 注文がない場合
    if (data.items.length === 0) continue
    // すでに同じ注文IDが存在する場合は追加しない（重複対策）
    if (orders.some((order) => order.checkout_id === data.checkout_id)) continue
    orders.push(data)
  }
  if (orders.length > 0) {
    // checkout_atが存在しないデータはupdated_atで並び替える
    switch (sortOrder) {
      case 'asc':
        orders.sort((a, b) => {
          if (!a.checkout_at || !b.checkout_at) sortKey = 'updated_at'
          return a[sortKey] < b[sortKey] ? -1 : 1
        })
        break
      case 'desc':
        orders.sort((a, b) => {
          if (!a.checkout_at || !b.checkout_at) sortKey = 'updated_at'
          return a[sortKey] > b[sortKey] ? -1 : 1
        })
        break
      default:
        orders.sort((a, b) => {
          if (!a.checkout_at || !b.checkout_at) sortKey = 'updated_at'
          return a[sortKey] < b[sortKey] ? -1 : 1
        })
        break
    }
    dispatch(fetchOrdersAction(orders))
  }
}

export default mergeListeningCheckoutWithItems
